import * as React from 'react';
export const IcDataCircle = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a10 10 0 100 20 10 10 0 000-20zm-1 13.75a1 1 0 01-2 0V11.1l-1.22 1.52a1 1 0 11-1.56-1.24l3-3.76a1 1 0 011.78.63v7.5zm6.78-3.13l-3 3.76a1 1 0 01-1.594-.054A1 1 0 0113 15.75v-7.5a1 1 0 012 0v4.65l1.22-1.52a1 1 0 011.56 1.24z'
      fill='currentColor'
    />
  </svg>
);
